import type {SlIcon} from '@shoelace-style/shoelace/shoelace';

export default class CustomerShopHint {
    constructor() {
        this._initCshopHint();
    }

    private _initCshopHint() {
        const cshopHintMetaNav: HTMLDivElement | null = document.querySelector('#header .top .cshop-hint');
        if (cshopHintMetaNav) {
            const closeCshopHintMetaNav: SlIcon | null = cshopHintMetaNav.querySelector('.headline sl-icon');
            closeCshopHintMetaNav!.addEventListener('click', () => {
                CustomerShopHint._setDisableHintCookie();
                cshopHintMetaNav.remove();
            });
        }

        const cshopHintBody: HTMLDivElement | null = document.querySelector('#header > .cshop-hint');
        if (cshopHintBody) {
            const closeCshopHintBody: SlIcon | null = cshopHintBody.querySelector('sl-icon.dismiss');
            closeCshopHintBody!.addEventListener('click', () => {
                CustomerShopHint._setDisableHintCookie();
                cshopHintBody.remove();
            });
        }
    }

    private static _setDisableHintCookie(): void {
        let exdate = new Date();
        exdate.setDate(exdate.getDate() + 365);

        document.cookie = 'cShopHintSeen=true;path=/;expires=' + exdate.toUTCString();
    }
}
